import * as type from '../types';

const initialState = {
  cities: [],
  districts: [],
  loading: false,
  error: false,
};

const geo = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_CITIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_CITIES_SUCCEEDED:
      return {
        ...state,
        cities: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_CITIES_FAILED:
      return {
        ...state,
        cities: [],
        loading: false,
        error: true,
      };
    case type.GET_DISTRICTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_DISTRICTS_SUCCEEDED:
      return {
        ...state,
        districts: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_DISTRICTS_FAILED:
      return {
        ...state,
        districts: [],
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}

export default geo;